import React from 'react';
import { cn } from '@billda/design-system';

interface PageContentAreaProps {
  isPanelOpen: boolean;
  panel?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Content column that yields space to the docked side panel. Margin
 * compensation follows the DS panel's `--ds-side-panel-width` variable (the
 * AppShell content region reads the same var, but page-level panels —
 * URL-driven, help panels, selection panels — compensate here where their
 * open state is known).
 */
export const PageContentArea: React.FC<PageContentAreaProps> = ({
  isPanelOpen,
  panel,
  children,
}) => {
  return (
    <div className="flex h-full">
      <div
        className={cn(
          'flex min-w-0 flex-1 flex-col overflow-x-hidden',
          isPanelOpen && 'lg:mr-(--ds-side-panel-width)'
        )}
      >
        <div className="flex h-full min-h-0 flex-col">{children}</div>
      </div>

      {panel}
    </div>
  );
};
